"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rotate = rotate;
exports.scale = scale;
exports.transform2D = transform2D;
exports.translate = translate;

/**
 * @module ol/geom/flat/transform
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */
function transform2D(flatCoordinates, offset, end, stride, transform, opt_dest) {
  var dest = opt_dest ? opt_dest : [];
  var i = 0;

  for (var j = offset; j < end; j += stride) {
    var x = flatCoordinates[j];
    var y = flatCoordinates[j + 1];
    dest[i++] = transform[0] * x + transform[2] * y + transform[4];
    dest[i++] = transform[1] * x + transform[3] * y + transform[5];
  }

  if (opt_dest && dest.length != i) {
    dest.length = i;
  }

  return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} angle Angle.
 * @param {Array<number>} anchor Rotation anchor point.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */


function rotate(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
  var dest = opt_dest ? opt_dest : [];
  var cos = Math.cos(angle);
  var sin = Math.sin(angle);
  var anchorX = anchor[0];
  var anchorY = anchor[1];
  var i = 0;

  for (var j = offset; j < end; j += stride) {
    var deltaX = flatCoordinates[j] - anchorX;
    var deltaY = flatCoordinates[j + 1] - anchorY;
    dest[i++] = anchorX + deltaX * cos - deltaY * sin;
    dest[i++] = anchorY + deltaX * sin + deltaY * cos;

    for (var k = j + 2; k < j + stride; ++k) {
      dest[i++] = flatCoordinates[k];
    }
  }

  if (opt_dest && dest.length != i) {
    dest.length = i;
  }

  return dest;
}
/**
 * Scale the coordinates.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} sx Scale factor in the x-direction.
 * @param {number} sy Scale factor in the y-direction.
 * @param {Array<number>} anchor Scale anchor point.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */


function scale(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
  var dest = opt_dest ? opt_dest : [];
  var anchorX = anchor[0];
  var anchorY = anchor[1];
  var i = 0;

  for (var j = offset; j < end; j += stride) {
    var deltaX = flatCoordinates[j] - anchorX;
    var deltaY = flatCoordinates[j + 1] - anchorY;
    dest[i++] = anchorX + sx * deltaX;
    dest[i++] = anchorY + sy * deltaY;

    for (var k = j + 2; k < j + stride; ++k) {
      dest[i++] = flatCoordinates[k];
    }
  }

  if (opt_dest && dest.length != i) {
    dest.length = i;
  }

  return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} deltaX Delta X.
 * @param {number} deltaY Delta Y.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */


function translate(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
  var dest = opt_dest ? opt_dest : [];
  var i = 0;

  for (var j = offset; j < end; j += stride) {
    dest[i++] = flatCoordinates[j] + deltaX;
    dest[i++] = flatCoordinates[j + 1] + deltaY;

    for (var k = j + 2; k < j + stride; ++k) {
      dest[i++] = flatCoordinates[k];
    }
  }

  if (opt_dest && dest.length != i) {
    dest.length = i;
  }

  return dest;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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